export const BigBannerPlaceholder =
	"https://t.rightinthebox.com/tights/litb/n6pcy5h07hs0_FgAEgY5gvRxBHePwb0J__mv_R_rB.png";

export const BannerBtnPlaceholder =
	"https://t.rightinthebox.com/tights/litb/c2nmc9jdwhk0_Fu0Vt0_sgFdXM99EPIjHFR0EaHFA.png";

export const ErrorpagePlaceholder =
	"https://t.rightinthebox.com/tights/litb/1n3ak87qnxi80_FisVWc02T3OfPVCB8PNcRnY_gMd_.png";
